export const REGISTRATION_PAGE_TITLE = 'Register account';
export const REGISTRATION_CONFIRM_PAGE_TITLE = 'Good to go!';
export const LOGIN_PAGE_TITLE = 'Login';
export const HOME_PAGE_TITLE = 'Home';
export const HOME_SEARCH_PAGE_TITLE = 'Search';
export const ACCOUNT_CUSTOMER_PAGE_TITLE = 'Account';
export const UPDATE_PASSWORD_PAGE_TITLE = 'Update password';
export const ACTIVATE_NEW_PASSWORD_PAGE_TITLE = 'Activate new password';
export const FORGOT_PASSWORD_PAGE_TITLE = 'Forgot password';

export const BOOKING_DETAILED_VIEW_PAGE_CUSTOMER_TITLE = 'Booking details';
export const BOOKINGS_CUSTOMER_PAGE_TITLE = 'Bookings';

export const EVENT_BOOKING_DETAILED_VIEW_PAGE_CUSTOMER_TITLE = 'Event booking details';
export const BOOKING_SUCCESS_PAGE_TITLE = 'Booking confirmation';
export const BOOKING_CANCEL_SUCCESS_PAGE_TITLE = 'Booking cancelled';
export const INVOICES_PAGE_TITLE = 'Invoices';
export const REMOVE_FROM_WAITLIST_PAGE_TITLE = 'Remove from waitlist';
export const OPERATIONS_DASHBOARD_PAGE_TITLE = 'Operations Dashboard';
export const UTILISATION_DASHBOARD_PAGE_TITLE = 'Utilisation Dashboard';

// ADMIN
export const ADMIN_PAGE_TITLE = 'Admin';
export const FERRY_SCHEDULE_PAGE_TITLE = 'Schedule';
export const STAFF_SCHEDULE_PAGE_TITLE = 'Schedule';
export const FERRY_TRIP_VIEW_PAGE_TITLE = 'View trip';
export const FERRY_TRIP_EDIT_PAGE_TITLE = 'Edit trip';
export const FERRY_TRIP_CREATE_PAGE_TITLE = 'Create trip';

// STAFF
export const REPORTS_PAGE_TITLE = 'Reports';
export const PROMOTIONS_PAGE_TITLE = 'Promotions';
export const USERS_PAGE_TITLE = 'Users';
export const PRICING_PAGE_TITLE = 'Pricing';
export const BOOKING_DETAILED_VIEW_PAGE_STAFF_TITLE = 'Customer booking details';
export const ACCOUNT_STAFF_VIEW_PAGE_TITLE = 'Customer account details';
export const CUSTOMER_BOOKINGS_PAGE_TITLE = 'Customer bookings';
export const CUSTOMER_TRANSACTIONS_PAGE_TITLE = 'Customer transactions';
export const STAFF_FEES_PAGE_TITLE = 'Fees';
export const VOUCHERS_PAGE_TITLE = 'Vouchers';
export const PARKING_RESERVATIONS_PAGE_TITLE = 'Parking Reservations';
export const PARKING_RESERVATION_DETAIL_PAGE_TITLE = 'Parking Details';
export const CUSTOMER_INVOICES_PAGE_TITLE = 'Customer invoices';

// CHECK-IN
export const CHECK_IN_VIEW_BOOKING_PAGE_TITLE = 'Ferry check-in - view booking';
export const CHECK_IN_ADD_BOOKING_PAGE_TITLE = 'Ferry check-in - add booking';
export const CHECK_IN_REVIEW_BOOKING_PAGE_TITLE = 'Ferry check-in - review booking';
export const CHECK_IN_SELECT_CUSTOMER_PAGE_TITLE = 'Ferry check-in - select customer';
export const CHECK_IN_MOVE_BOOKING_PAGE_TITLE = 'Ferry check-in - move booking';
export const CHECK_IN_SCAN_QR_PAGE_TITLE = 'Ferry check-in - scan QR';
export const CHECK_IN_PAGE_TITLE = 'Ferry check-in';
export const CHECK_IN_PARKING_PAGE_TITLE = 'Ferry check-in parking';
export const EVENT_CHECK_IN_PAGE_TITLE = 'Event check-in';
export const EVENT_CHECK_IN_VIEW_BOOKING_PAGE_TITLE = 'Event check-in - view booking';
export const EVENT_CHECK_IN_ADD_BOOKING_PAGE_TITLE = 'Event check-in - add booking';
export const EVENT_CHECK_IN_REVIEW_BOOKING_PAGE_TITLE = 'Event check-in - review booking';
export const EVENT_CHECK_IN_SELECT_CUSTOMER_PAGE_TITLE = 'Event check-in - select customer';
export const EVENT_CHECK_IN_MOVE_BOOKING_PAGE_TITLE = 'Event check-in - move booking';
export const EVENT_CHECK_IN_SCAN_QR_PAGE_TITLE = 'Event check-in - scan QR';

// EVENTS
export const EVENTS_LIST_VIEW_PAGE_TITLE = 'Upcoming events';
export const EVENT_VIEW_PAGE_TITLE = 'View event';
export const EVENT_EDIT_PAGE_TITLE = 'Edit event';
export const EVENT_CREATE_PAGE_TITLE = 'Create event';

export const PageTitles = {
	DefaultPricing: 'Default pricing',
	FerryTripImport: 'Ferry trip import',
	RecurringSchedules: 'Recurring schedules',
	BulkTripPricing: 'Bulk trip pricing',
	InvoicedBookingReprice: 'Update invoiced booking prices',
	BannerMessages: 'Banners',
	Admin: 'Admin',
	AppConfiguration: 'App configuration',
	EmailBuilder: 'Email template builder',
	Products: 'Products',
} as const;
